import { useContext } from "react";

import { StoresContext } from "./StoresContext.ts";

export const useStores = () => {
  return useContext(StoresContext);
};
